import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BaseComponent } from './views/layout/base/base.component';
import { AuthGuard } from './core/guard/auth.guard';
import { RoleGuard } from './core/guard/role.guard';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';


const routes: Routes = [
  { path: 'auth', loadChildren: () => import('./views/pages/auth/auth.module').then(m => m.AuthModule) },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'order',
        canActivate: [RoleGuard],
        data: { roles: ['ADMI', 'CAJE', 'MOZO'] },
        loadChildren: () => import('./views/pages/order/order.module')
          .then(m => m.OrderModule)
      },
      {
        path: 'user',
        canActivate: [RoleGuard],
        data: { roles: ['ADMI'] },
        loadChildren: () => import('./views/pages/user/user.module')
          .then(m => m.UserModule)
      },
      {
        path: 'quick-note',
        canActivate: [RoleGuard],
        data: { roles: ['ADMI'] },
        loadChildren: () => import('./views/pages/quicknote/quicknote.module')
          .then(m => m.QuickNoteModule)
      },
      {
        path: 'location',
        canActivate: [RoleGuard],
        data: { roles: ['ADMI', 'CAJE', 'MOZO'] },
        loadChildren: () => import('./views/pages/location/location.module')
          .then(m => m.LocationModule)
      },
      {
        path: 'expense',
        canActivate: [RoleGuard],
        data: { roles: ['ADMI', 'CAJE'] },
        loadChildren: () => import('./views/pages/expense/expense.module')
          .then(m => m.ExpenseModule)
      },
      {
        path: 'product',
        canActivate: [RoleGuard],
        data: { roles: ['ADMI'] },
        loadChildren: () => import('./views/pages/product/product.module')
          .then(m => m.ProductModule)
      },
      {
        path: 'client',
        canActivate: [RoleGuard],
        data: { roles: ['ADMI', 'CAJE'] },
        loadChildren: () => import('./views/pages/client/client.module')
          .then(m => m.ClientModule)
      },
      {
        path: 'configuration',
        canActivate: [RoleGuard],
        data: { roles: ['ADMI'] },
        loadChildren: () => import('./views/pages/configuration/configuration.module')
          .then(m => m.ConfigurationModule)
      },
      {
        path: 'cashbox',
        canActivate: [RoleGuard],
        data: { roles: ['ADMI', 'CAJE'] },
        loadChildren: () => import('./views/pages/cashbox/cashbox.module')
          .then(m => m.CashboxModule)
      },
      {
        path: 'business',
        canActivate: [RoleGuard],
        data: { roles: ['SYSA', 'ADMI'] },
        loadChildren: () => import('./views/pages/business/business.module')
          .then(m => m.BusinessModule)
      },
      {
        path: 'apps',
        loadChildren: () => import('./views/pages/apps/apps.module').then(m => m.AppsModule)
      },
      {
        path: 'ui-components',
        loadChildren: () => import('./views/pages/ui-components/ui-components.module').then(m => m.UiComponentsModule)
      },
      {
        path: 'advanced-ui',
        loadChildren: () => import('./views/pages/advanced-ui/advanced-ui.module').then(m => m.AdvancedUiModule)
      },
      {
        path: 'form-elements',
        loadChildren: () => import('./views/pages/form-elements/form-elements.module').then(m => m.FormElementsModule)
      },
      {
        path: 'advanced-form-elements',
        loadChildren: () => import('./views/pages/advanced-form-elements/advanced-form-elements.module').then(m => m.AdvancedFormElementsModule)
      },
      {
        path: 'charts-graphs',
        loadChildren: () => import('./views/pages/charts-graphs/charts-graphs.module').then(m => m.ChartsGraphsModule)
      },
      {
        path: 'tables',
        loadChildren: () => import('./views/pages/tables/tables.module').then(m => m.TablesModule)
      },
      {
        path: 'icons',
        loadChildren: () => import('./views/pages/icons/icons.module').then(m => m.IconsModule)
      },
      {
        path: 'general',
        loadChildren: () => import('./views/pages/general/general.module').then(m => m.GeneralModule)
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: '**', redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  },
  {
    path: 'error',
    component: ErrorPageComponent,
    data: {
      'type': 404,
      'title': 'Page Not Found',
      'desc': 'Oopps!! The page you were looking for doesn\'t exist.'
    }
  },
  {
    path: 'error/:type',
    component: ErrorPageComponent
  },
  { path: '**', redirectTo: 'error', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
